import { Component } from "vue-property-decorator";
import Vue from "vue";
import WorkspaceOptions, { Element } from "@/store/modules/WorkspaceOptions";
import { getModule } from "vuex-module-decorators";


@Component
export default class ElementSelect extends Vue {

    selectFactorElement(id: string) {
        this.selectElement(id, "FACTOR", false, undefined);
    }

    selectViewpointFactorElement(viewpointId: string, id: string) {
        this.selectElement(id, "FACTOR", false, viewpointId);
    }

    selectFactorGroupElement(id: string) {
        this.selectElement(id, "FACTOR_GROUP", false, undefined);
    }

    selectViewpointFactorGroupElement(viewpointId: string, id: string) {
        this.selectElement(id, "FACTOR_GROUP", false, viewpointId);
    }

    selectTemplateFactorElement(id: string) {
        this.selectElement(id, "FACTOR", true, undefined);
    }

    selectTemplateViewpointFactorElement(viewpointId: string, id: string) {
        this.selectElement(id, "FACTOR", true, viewpointId);
    }

    selectTemplateFactorGroupElement(id: string) {
        this.selectElement(id, "FACTOR_GROUP", true, undefined);
    }

    selectTemplateViewpointFactorGroupElement(viewpointId: string, id: string) {
        this.selectElement(id, "FACTOR_GROUP", true, viewpointId);
    }

    selectElement(id: string, type: Element["type"], isTemplate: boolean, viewpointId: string | undefined) {
        let selectedElement: Element = {
            id: id,
            isTemplate: isTemplate,
            type: type,
            viewpointId: viewpointId
        }
        getModule(WorkspaceOptions).selectElement(selectedElement)
    }
}